<template>
    <search-list ref="sl" :where="where" api-path="/eventLog/list"  :searchKeys="searchKeys" :attributes="group" notSearchAll :copyFrom="copyFrom" :handleResponse="handleResponse" :beforeRefresh="beforeRefresh" :pageSizes="[200]"  >
		<div class="col">
			<div class="row">
				<mm-lc title="Time Zone">
					<mm-time-zone v-model="where.time_zone" :clearable="false"/>
				</mm-lc>
				<mm-lc title="Install Time">
				<mm-date-range v-model="where.install_time" />
			</mm-lc>
					<mm-lc title="Channel">
				<mm-channel-select v-model="where.networkid" multiple />
			</mm-lc>
			<mm-lc title="Sub">
				<el-input v-model="where.sub_channel" clearable></el-input>
			</mm-lc>
			<mm-lc title="Group">
				<mm-select v-model="group" :options="groupOptions" multiple returnArray/>
			</mm-lc>
			<mm-lc title="Report Model">
				<mm-select v-model="where.model" :options="modelOptions"/>
			</mm-lc>
			<mm-lc title="Rate Mode">
				<mm-select v-model="where.rateMode" :options="rateOptions"  />
			</mm-lc>
				<mm-lc title="Details">
					<el-switch v-model="details"></el-switch>
				</mm-lc>
			</div>
			<div class="row">
					<mm-lc title="Event Time">
				<mm-date-range v-model="where.event_time" notDefaultValue/>
			</mm-lc>
				<mm-lc title="Event Name">
				<el-input v-model="where.event_name" clearable></el-input>
			</mm-lc>
				<mm-lc title="Event Period">
				<mm-number-range v-model="where.period"></mm-number-range>
			</mm-lc>
				<mm-lc title="Hidden">
				<mm-select v-model="hidden" :options="hiddenOptions" multiple returnArray/>
			</mm-lc>
			</div>
		</div>
		
		
		<mm-table slot="dataTable" slot-scope="res" :res="res" @header-click="headerClick" >
			<el-table-column label="Time" prop="time" key="time" v-if="columnShow.time"/>
			<el-table-column label="Adv. Id" prop="adv_id" key="adv_id" width="90"/>
			<el-table-column label="Adv. name" prop="adv" key="adv" width="100" >
				<mm-get-detail slot-scope="sp" :row_name="sp.row.adv" :row_id="sp.row.adv_id" row_type='adv' />
			</el-table-column>
			<el-table-column label="Offer Id" prop="offerid" >
				<mm-get-detail slot-scope="sp" row_type="offer" :row_id="sp.row.offerid" :row_name="sp.row.offerid" >
					<div class="getOfferid el-icon-edit-outline" @click="getOfferid(sp.row.offerid)"></div>
				</mm-get-detail>
			</el-table-column>
			<el-table-column label="Offer Name" width="180" prop="offer_name" />
				<el-table-column label="Channel ID" width="80" prop="networkid" v-if="columnShow.networkid"/>
			<el-table-column label="Channel" width="120" key="network" prop="network" v-if="columnShow.network" sortable>
				<mm-get-detail slot-scope="sp" :row_id="sp.row.networkid" :row_name="sp.row.network" row_type="channel"/>
			</el-table-column>
			<el-table-column label="Sub" prop="sub_channel" v-if="columnShow.sub_channel"/>
			<el-table-column label="Event Name" prop="event_name" v-if="columnShow.event_name" />
			<mm-summary-column label="Event Count" prop="event_count" v-if="columnShow.event_count" />
			<!-- <mm-summary-column label="Conver" prop="conver" key="conver" v-if="columnShow.conver&&rows[0].conver" sortable/> -->
			<!-- <mm-summary-column label="Sent Conver" prop="sent_conver" key="sent_conver" v-if="columnShow.sent_conver&&rows[0].sent_conver" sortable/> -->
			<mm-summary-column  v-for="e of events" :label="e" :prop="e" :key="e" >
				<!-- <template slot="header">
       <div @click="console.log(e)">{{e}}</div>
      </template> -->
			</mm-summary-column>
			<el-table-column label="Action" v-if="columnShow.network">
				<template slot-scope="sp">
       <el-button @click="editCamp(sp.row)">Edit</el-button>
      </template>
			</el-table-column>
			
		</mm-table>
	</search-list>
</template>

<script>


export default {
	data(){
		const searchKeys = {
			offerid: { label: "Offer Id" }
		};
		const groupOptions = [
			// ['offerid','Offer Id'],
			// ['event_name','Event Name'],
			['networkid','Channel'],
			['sub_channel','Sub Channel(APP ID)'],
		].map(v => {
			return { value: v[0], label: v[1] };
		});
		const modelOptions = [
			['daily','Daily'],
		].map(v => {
			return { value: v[0], label: v[1] };
		});
		const hiddenOptions = [
			// ['conver', 'Conver'],
			// ['sent_conver', 'Sent Conver'],
			['time', 'Time']
		].map(v => {
			return { value: v[0], label: v[1] };
		});
		const rateOptions = [
			['event','Event Rate'],
			['user','User Rate'],
		].map(v => {
			return { value: v[0], label: v[1] };
		});
		return{
			columnShow:{
				networkid:false,
				network:false,
				sub_channel:false,
				event_name:false,
				event_count:false,
				conver:false,
				sent_conver:false,
				time:false,
			},
			rateOptions,
			searchKeys,
			eventNameOptions:[],
			where:{
				networkid:'',
				event_name:'',
				isGetRate:false,
				time_zone:8,
			},
			group:[],
			groupOptions,
			modelOptions,
			events:[],
			hiddenOptions,
			hidden:[ 'time' ],
			details: true,
			rows:[],
			outlineRows:[],
			summary: [],
			outlineSummary: []
		}
	},
	watch: {
		hidden(arr) {
			this.hiddenHead(arr, true);
		},
		details(bool) {
			if (bool) {
				this.$refs.sl.rows = this.rows;
				this.$refs.sl.summary = this.summary;
			} else {
				this.$refs.sl.rows = this.outlineRows;
				this.$refs.sl.summary = this.outlineSummary;
			}
		}
	},
	methods:{
		async handleResponse(res){
			this.events = res.events||[];
			const row = res.rows[0];
			for(let key in this.columnShow){
				this.columnShow[key] = row[key] === undefined?false:true;
			}
			this.rows = JSON.parse(JSON.stringify(res.rows));
			this.outlineRows = JSON.parse(JSON.stringify(res.rows));
			this.summary = JSON.parse(JSON.stringify(res.summary));
			this.outlineSummary = JSON.parse(JSON.stringify(res.summary));
			for (const key1 in this.outlineRows) {
				for (const key2 in this.outlineRows[key1]) {
					if (typeof this.outlineRows[key1][key2] === 'string' && key2 !== 'offer_name') {
						this.outlineRows[key1][key2] = this.outlineRows[key1][key2].replace(/\s\(\d+\)/, '');
					}
				}
			}
			for (const key in this.outlineSummary) {
				if (typeof this.outlineSummary[key] === 'string') {
					this.outlineSummary[key] = this.outlineSummary[key].replace(/\s\(\d+\)/, '');
				}
			}
			this.details = true;
			this.hiddenHead(this.hidden);
		},
		beforeRefresh(){
			const where  = this.$refs.sl.getCondition;
			if (where.rateMode && (!where.offerid || !where.install_time )) {
				throw 'Offerid and Install Time is Required';
			}
		},
		headerClick(column){
			const label = column.label;
			if(this.events.indexOf(label)>-1){
				this.where.event_name = label;
			}
		},
		getOfferid(offerid){
			this.$refs.sl.searchValue = offerid;
		},
		copyFrom(rows, title_name){
			const events = this.events;
			rows.forEach(row=>{
				for(let k of events){
					row[k] = row[k].replace(/\(\d+\)/,'');
				}
				if (this.hidden.indexOf('conver') !== -1 && row.conver) {
					delete row.conver;
					delete title_name.conver;
				}
				if (this.hidden.indexOf('sent_conver') !== -1 && row.sent_conver) {
					delete row.sent_conver;
					delete title_name.sent_conver;
				}
			})
			return rows;
		},
		editCamp(row){
			window.open(`/campEdit?offer_id=${row.offerid}&networkid=${row.networkid}`);
		},
		hiddenHead(arr, isWatch = false) {
			for(const column of [ 'conver', 'sent_conver', 'time' ]) {
				if (arr.indexOf(column) !== -1) {
					this.columnShow[column] = false;
				} else if(isWatch) {
					this.columnShow[column] = true;
				}
			}
		}
	}
}
</script>
<style scoped>
.row{
	display:flex;
	flex-direction: row;
}
.col{
	display:flex;
	flex-direction: column;
}
.getOfferid{
	display: inline;
	margin-left: 5px;
}
</style>
